import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/"); return; }
    const sid = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setUser(data.user);
        // Choose where to send the user after sign-in:
        //   1. The explicit redirect saved on the login page
        //   2. /admin for admins, otherwise /
        let dest = "/";
        try {
          const saved = sessionStorage.getItem("js_post_login_redirect");
          if (saved) { dest = saved; sessionStorage.removeItem("js_post_login_redirect"); }
          else if (data.user?.is_admin) dest = "/admin";
        } catch {
          if (data.user?.is_admin) dest = "/admin";
        }
        window.history.replaceState({}, "", dest);
        nav(dest, { replace: true, state: { user: data.user } });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);
  return <div className="section container-narrow" data-testid="auth-callback">Signing you in…</div>;
}
